export default "__VITE_ASSET__XQdImx6X__"